import { forwardRef } from "react";
import { styled } from "styled-components";
import StatusIndicator, {
  IndicatorProps,
} from "components/lib/statusIndicator";
import { Slot, SlotStatus, SlotPaidStatus, TemplateNames } from "core/types";

export const Container = styled.div`
  display: flex;
`;

const SlotColorStatus = forwardRef(
  (
    { event, templateName }: { event: Slot; templateName: string },
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const getSlotColor = (): IndicatorProps["variant"] => {
      if (
        event.status === SlotStatus.OPEN &&
        (templateName === TemplateNames.revisit ||
          templateName === TemplateNames.adhd_screening)
      ) {
        return "medium_grey";
      }

      if (event.status === SlotStatus.OPEN) {
        return "transparent";
      }

      if (
        event.status === SlotStatus.BOOKED ||
        event.status === SlotStatus.UNAVAILABLE
      ) {
        if (event.payed === SlotPaidStatus.PAID) {
          return "primary";
        }
        return "orange";
      }

      return "error";
    };

    return (
      <Container ref={ref} data-testid="slot-color-status-container">
        <StatusIndicator
          variant={getSlotColor()}
          data-testid="slot-color-status"
        />
      </Container>
    );
  },
);

SlotColorStatus.displayName = "SlotColorStatus";

export default SlotColorStatus;
